import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import SubjobsGrid from "./SubjobsGrid";
import axios from "axios";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

const Templates = () => {
  const navigate = useNavigate();
  const [jobTypeName, setJobTypeName] = useState("");
  const [productEntries, setProductEntries] = useState([]);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openSubmitSnackbar, setOpenSubmitSnackbar] = useState(false);
  // console.log("Subjobs(productEntries) From Subjob grid:", productEntries);

  const handleInputChange = (e) => {
    setJobTypeName(e.target.value);
  };

  const backForm = () => {
    navigate("/newJobForm");
  };

  let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
    ? JSON.parse(localStorage.getItem("apiPaths"))
    : "-";
  // console.log('apiPaths_from_local_storage',apiPaths_from_local_storage)

  let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMJobType`;

  const handleSubmit = async () => {
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    console.log("productEntries:", productEntries);
    const payloadJobType = productEntries?.map((item, index) => ({
      CmpCode: company_code_from_local_storage,
      mode: "ENTRY",
      job_type: jobTypeName,
      task_description: item?.itemDescription,
      task_Group: item?.itemGroup,
      Task_Serial: item?.id,
    }));



  //   [
  //   {
  //     "CmpCode": "CUBIX",
  //     "mode": "ENTRY",
  //     "job_type": "Sea Cargo -Import",
  //     "task_description": "Document Collection",
  //     "task_Group": "Task Group",
  //     "Task_Serial": "1"
  //   },
  //   {
  //     "CmpCode": "CUBIX",
  //     "mode": "ENTRY",
  //     "job_type": "Sea Cargo -Import",
  //     "task_description": "Document Varification",
  //     "task_Group": "Task Group",

  //     "Task_Serial": "2"
  //   },
  //   {
  //     "CmpCode": "CUBIX",
  //     "mode": "ENTRY",
  //     "job_type": "Sea Cargo -Import",
  //     "task_description": "Contact Customs",
  //     "task_Group": "Task Group",
  //     "Task_Serial": "3"
  //   }
  // ]

    console.log("final payload for job type:", payloadJobType);

    try {
      const response = await axios.post(apiUrl, payloadJobType, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = response.data;
      console.log("data after posting new job type", data);
      setOpenSubmitSnackbar(true);
      setTimeout(() => {
        navigate("/newJobForm");
      }, 800);
    } catch (err) {
      console.error("Error while posting new job type", err);
      setOpenSnackbar(true);
    }
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const handleCloseSubmitSnackbar = () => {
    setOpenSubmitSnackbar(false);
    // setDuplicateItemCodeSnackbar(false);
  };

  return (
    <div className="p-6 w-full h-full bg-transparent">
      {/* Header */}
      <div className="mb-6 flex items-center gap-4">
        <button
          onClick={backForm}
          className="text-gray-700 hover:bg-gray-200 p-2 rounded transition"
        >
          <ArrowLeft className="w-6 h-6" />
        </button>
        <h2 className="text-2xl font-semibold text-gray-700">
          Create Job Type
        </h2>
      </div>

      {/* Form */}
      <div className="space-y-6 w-full max-w-2xl">
        {/* Job Type Name */}
        <div>
          <label className="text-gray-600 text-sm font-medium block mb-1">
            Job Type Name
          </label>
          <input
            name="jobTypeName"
            value={jobTypeName}
            onChange={handleInputChange}
            className="w-full px-4 py-2 text-lg border-b border-gray-400 placeholder:text-gray-400 bg-white rounded outline-none"
            placeholder="Enter Job Type Name..."
          />
        </div>

        <div>
          <SubjobsGrid
            productEntries={productEntries}
            setProductEntries={setProductEntries}
          />
        </div>

        {/* Submit Button */}
        <div className="pt-1">
          <button
            onClick={handleSubmit}
            className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 transition"
          >
            Save Job Type
          </button>
        </div>
      </div>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          onClose={handleCloseSnackbar}
          severity="error"
          sx={{ width: "100%" }}
        >
          Error while adding job type!
        </MuiAlert>
      </Snackbar>
      {/* ) : ( */}
      <Snackbar
        open={openSubmitSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSubmitSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          onClose={handleCloseSnackbar}
          severity="success"
          sx={{ width: "100%" }}
        >
          Job Type Submitted Successfully!
        </MuiAlert>
      </Snackbar>
    </div>
  );
};

export default Templates;
